<template>
    <article class="attachment" :class="{ 'reply__attachment' : isReply }">
        <img v-if="attachment.is_image" ref="image" @click.prevent="preview" class="attachment__image" :src="attachment.thumbnail_url"/>
        <a v-else :href="attachment.url" class="attachment__file" :download="attachment.original_name">
            <span class="file" :class="[attachment.type, { 'file--small' : isReply }]"></span>
            <p v-if="! isReply" class="attachment__name">{{ attachment.original_name }}</p>
        </a>
    </article>
</template>

<script>
export default {
    props: {
        attachment: {
            required: true,
            type: Object
        },
        isReply: {
            required: false,
            default: false,
            type: Boolean
        }
    },

    mounted () {
        if (this.attachment.is_image) {
            this.$refs.image.addEventListener('load', () => {
                this.$emit('loaded')
            })
        }
    },

    methods: {
        preview () {
            window.open(this.attachment.url, '_blank')
        }
    }
}
</script>
